import { useEffect } from 'react';

const RESOURCE_LABELS = {
  contacts: 'contacts',
  users: 'users',
  workspaces: 'workspaces',
  icps_per_workspace: 'ICPs',
};

export default function LimitReachedModal({ open, error, onClose, onUpgrade }) {
  useEffect(() => {
    if (!open) return;
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const resource = error?.resource || 'items';
  const resourceLabel = RESOURCE_LABELS[resource] || resource.replace(/_/g, ' ');
  const current = error?.current ?? 0;
  const limit = error?.limit ?? '?';
  const tier = error?.tier || 'your current';
  const attempted = error?.attempted;
  const shortfall = error?.shortfall;

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: '12px', padding: '2rem', maxWidth: '460px', width: '90%', boxShadow: '0 20px 50px rgba(0,0,0,0.25)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', marginBottom: '0.85rem' }}>
          <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#FFF5F5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C53030" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2L2 22h20L12 2z" />
              <line x1="12" y1="9" x2="12" y2="14" />
              <line x1="12" y1="18" x2="12.01" y2="18" />
            </svg>
          </div>
          <h2 style={{ margin: 0, fontSize: '1.15rem', fontWeight: '700', color: '#1A1A1A' }}>Plan limit reached</h2>
        </div>

        <p style={{ margin: '0 0 1rem', fontSize: '0.9rem', color: '#4A5568', lineHeight: '1.55' }}>
          {attempted
            ? <>This action would add <strong>{attempted.toLocaleString('en-GB')} {resourceLabel}</strong>, but your <strong>{tier}</strong> plan is limited to <strong>{Number(limit).toLocaleString('en-GB')} {resourceLabel}</strong>.</>
            : <>You're at the <strong>{resourceLabel}</strong> limit for the <strong>{tier}</strong> plan ({Number(current).toLocaleString('en-GB')} of {Number(limit).toLocaleString('en-GB')}).</>
          }
        </p>

        <div style={{ background: '#FAFAF8', borderRadius: '8px', padding: '0.85rem 1rem', marginBottom: '1.25rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '0.78rem', color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '600' }}>
            {shortfall ? 'Over limit by' : 'Current usage'}
          </span>
          <span style={{ fontSize: '1.1rem', fontWeight: '700', color: '#C53030' }}>
            {shortfall
              ? <>{Number(shortfall).toLocaleString('en-GB')} {resourceLabel}</>
              : <>{Number(current).toLocaleString('en-GB')} / {Number(limit).toLocaleString('en-GB')}</>
            }
          </span>
        </div>

        <div style={{ display: 'flex', gap: '0.6rem' }}>
          <button onClick={onClose} style={{ flex: 1, padding: '0.7rem', fontSize: '0.85rem', fontWeight: '500', background: '#fff', color: '#4A5568', border: '1px solid #D4CFC9', borderRadius: '6px', cursor: 'pointer' }}>
            Cancel
          </button>
          <button onClick={() => { onClose(); onUpgrade && onUpgrade(); }} style={{ flex: 1, padding: '0.7rem', fontSize: '0.85rem', fontWeight: '600', background: '#8B1A1A', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
            Upgrade plan
          </button>
        </div>
      </div>
    </div>
  );
}
